import Blue from "~/core";

new Blue({
  name: "table-responsive",
  selector: "table.table-responsive",
  setup(table) {
		let mobileTable = document.createElement("div");
		mobileTable.classList.add("table-mobile");
		const columnHeaders = [...table.querySelectorAll("thead tr th:not(:first-child)")];
		const rows = [...table.querySelectorAll("tbody tr")];
		
		const generateDiv = (parent, contentEl, className, position) => {
			const content = document.createElement("div");
			content.classList.add(className);
			content.innerHTML = contentEl.innerHTML;
			parent.insertAdjacentElement(position, content);
		}

		columnHeaders.forEach((header, i) => {
			let card = document.createElement("div");
			card.classList.add("table-mobile__card");
			let headCell = document.createElement("div");
			headCell.classList.add("table-mobile__cell");
			headCell.classList.add("table-mobile__cell--head");
			generateDiv(headCell, header, "table-mobile__content", "beforeend");
			card.insertAdjacentElement("beforeend", headCell);
			rows.forEach((row, j) => {
				const rowHeader = row.querySelector("th");
				const rowCell = [...row.querySelectorAll("td")][i];
				let contentCell = document.createElement("div");
				contentCell.classList.add("table-mobile__cell");
				generateDiv(contentCell, rowHeader, "table-mobile__heading", "afterbegin");
				generateDiv(contentCell, rowCell, "table-mobile__content", "beforeend");
				card.insertAdjacentElement("beforeend", contentCell);
			});
			mobileTable.insertAdjacentElement("beforeend", card);
		})
		
		table.insertAdjacentElement("afterend", mobileTable);
  }
});